.text-collapse {
  margin-bottom: 1rem;
  button {
    background: none;
    border: none;
    font-size: 1.25rem;
    cursor: pointer;
    text-decoration: underline;

    display: inline-block;

    &:hover {
      text-decoration: none;
    }
  }
}
